module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAABT0lEQVQ4jWM8wsBwiIGBgYmBduADCwMDgxUDAwMzDS35xERjX4DAX5AF/2hsyR+svpDs7WWw/v8fjg3u3mVgUVMDyyGLo2MOJyestmBYAlKoVFTEcK+vj+EoIyPDWWdnBhYeHgbFSZPA8q927mT4eOkSWA4d/9i3D6slLOgCrGJiYA0wANL48fx5Bm5VVZLCCK9PPq9YgcLnjYhgELKxYfh6+zbZlmD4BAZMXr5kYBcTg/Nve3jA2fx6euA4QAag4H1eXEyaJWfExeE+UW5tZdA4epThhrU1WAwUJ1f09Yn2CcE8Agq+pwsWMAhbWcFTGKkAwxKQi3UuXsRqDIuMDHUseTp5MjjMQZaBXA7KM/I5OQxvjx3DmUQJAYw4AQXPPVNTBumYGAbzmzfBYiALYPFBDgCVwn9oXEC+BgUXIufRBrCCgus1DUtiRgYGhrcAVe52tTxGMSAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/byt/3F.png
// module id = s+6I
// module chunks = 0